// Fallback contact channel: used when the storefront checkout is disabled or unavailable.
export const WHATSAPP_ORDER_PHONE = '5543991301093';

export function whatsappOrderUrl(message, phone = WHATSAPP_ORDER_PHONE) {
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
